import { render, staticRenderFns } from "./BrightcovePartnerPlayer.vue?vue&type=template&id=5b440d3b"
import script from "./BrightcovePartnerPlayer.vue?vue&type=script&lang=js"
export * from "./BrightcovePartnerPlayer.vue?vue&type=script&lang=js"
import style0 from "./BrightcovePartnerPlayer.vue?vue&type=style&index=0&id=5b440d3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports